import classnames from 'classnames';
import styles from '../card.module.scss';

export type CardTitleProps = {
  children: React.ReactNode;
  className?: string;
  style?: any; // contextStyle type
};

const CardTitle = ({
  children,
  className,
  style = { mobile: {} },
}: CardTitleProps) => (
  <div
    style={context.handleStyle(style)}
    className={classnames(styles.title, className)}
  >
    {children}
  </div>
);

export default CardTitle;
